const BASE_URL = 'https://api.payroom.tech/v1/'
const SOCKET_URL = 'https://api.payroom.tech/'

export {
    BASE_URL,
    SOCKET_URL
}

